import styled from 'styled-components';
import React, { FC } from 'react';
import { EmptyState, MobileTable, palette, Theme } from '@dev/ee-components';
import { isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';

const EmptyStateWrapper = styled.div`
    ${Theme.breakpoints.down('xs')} {
        padding-top: 32px;
        margin-top: 32px;
    }
    background: ${palette.basic.paper};

    & > div {
        padding: 72px 16px;
    }
`;

const MobileTableWrapper = styled.div`
    margin-top: 32px;
`;
interface MobileLogsTableInterface {
    rows: any;
    headers: any;
    isLoading: boolean;
    onViewDetailsClick(msgID: string): void;
    infiniteScrollProps: {
        next(): void;
        hasMore: boolean;
        loader: JSX.Element;
        dataLength: number;
    };
}

export const MobileLogsTable: FC<MobileLogsTableInterface> = ({
    rows,
    headers,
    isLoading,
    onViewDetailsClick,
    infiniteScrollProps,
}: MobileLogsTableInterface): JSX.Element => {
    const { t } = useTranslation();

    if (!isLoading && isEmpty(rows)) {
        return (
            <EmptyStateWrapper>
                <EmptyState background="#fff" text={t('thereisnodatatodisplay')} />
            </EmptyStateWrapper>
        );
    }

    return (
        <MobileTableWrapper>
            <MobileTable
                rows={rows}
                headers={headers}
                onClickButton={(_, clickedRow: Record<string, any>): void => {
                    onViewDetailsClick(clickedRow.id);
                }}
                infiniteScrollProps={infiniteScrollProps}
                isWrapTextEnabled
                expandedRows={
                    {
                        email: true,
                        to: true,
                    } as any
                }
            />
        </MobileTableWrapper>
    );
};
